import { FC } from "react";
import { ThemeProvider } from "@mui/material";
import { theme } from "src/theme/theme";
import { getLanguage } from "src/utils/Languages/LanguageContext";
import SubscriptionBenefitsTable from "./SubscriptionBenefitsTable";

interface Props {
  companyId: string;
  employeeId: string;
}

const SubscriptionBenefitsTab: FC<Props> = ({ companyId, employeeId }) => {
  const language = getLanguage();

  return (
    <ThemeProvider theme={theme({ language })}>
      <SubscriptionBenefitsTable
        companyId={companyId}
        employeeId={employeeId}
      />
    </ThemeProvider>
  );
};

export default SubscriptionBenefitsTab;
